import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { hrmsGetRequest, hrmsPostRequest, hrmsUpdateRequest, hrmsDeleteRequest } from "../services/index";

const API_URL = "/api/warnings"; // Matches your backend route

// Fetch Warnings
export const fetchWarnings = createAsyncThunk("warnings/fetch", async () => {
  const response = await hrmsGetRequest(API_URL);
  console.log("API Response:", response.data); 
  return response.data;
});

// Fetch Warnings by Teacher Email
export const fetchWarningsByEmail = createAsyncThunk("warnings/fetchByEmail", async (email) => {
  const response = await hrmsGetRequest(`${API_URL}/teacher/${email}`);
  return response.data;
});

// Add Warning
export const addWarning = createAsyncThunk("warnings/add", async (warningData) => {
  const response = await hrmsPostRequest(API_URL, warningData);
  return response.data;
});

// Update Warning
export const updateWarning = createAsyncThunk("warnings/update", async ({ id, updatedData }) => {
  const response = await hrmsUpdateRequest(`${API_URL}/${id}`, updatedData);
  return response.data;
});

// Delete Warning
export const deleteWarning = createAsyncThunk("warnings/delete", async (id) => {
  await hrmsDeleteRequest(`${API_URL}/${id}`);
  return id;
});

// Justification Actions
// Fetch All Justifications
export const fetchAllJustifications = createAsyncThunk("warnings/fetchAllJustifications", async () => {
  const response = await hrmsGetRequest(`${API_URL}/justifications`);
  return response.data;
});

// Fetch Justifications by Warning ID
export const fetchJustificationsByWarningId = createAsyncThunk("warnings/fetchJustificationsByWarningId", async (warningId) => {
  const response = await hrmsGetRequest(`${API_URL}/${warningId}/justification`);
  return response.data;
});

// Create Justification
export const createJustification = createAsyncThunk("warnings/createJustification", async ({ warningId, email, justificationText }) => {
  const response = await hrmsPostRequest(`${API_URL}/${warningId}/justification`, {
    email,
    justificationText
  });
  return response.data;
});

// Update Justification Status
export const updateJustificationStatus = createAsyncThunk("warnings/updateJustificationStatus", async ({ id, status }) => {
  const response = await hrmsUpdateRequest(`${API_URL}/justification/${id}/status`, { status });
  return response.data;
});

// Update Justification
export const updateJustification = createAsyncThunk("warnings/updateJustification", async ({ warningId, id, justification }) => {
  const response = await hrmsUpdateRequest(`${API_URL}/${warningId}/justifications/${id}`, { justification });
  return response.data;
});

const warningSlice = createSlice({
  name: "warnings",
  initialState: {
    warnings: [],
    userWarnings: [], // Warnings for current user
    justifications: [], // All justifications
    warningJustifications: [], // Justifications for specific warning
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch Warnings
      .addCase(fetchWarnings.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchWarnings.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.warnings = action.payload;
      })
      .addCase(fetchWarnings.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      // Fetch Warnings by Email
      .addCase(fetchWarningsByEmail.fulfilled, (state, action) => {
        state.userWarnings = action.payload;
      })
      // Add Warning
      .addCase(addWarning.fulfilled, (state, action) => {
        state.warnings.push(action.payload);
      })
      // Update Warning
      .addCase(updateWarning.fulfilled, (state, action) => {
        const index = state.warnings.findIndex((w) => w.id === action.payload.id);
        if (index !== -1) {
          state.warnings[index] = action.payload;
        }
      })
      // Delete Warning
      .addCase(deleteWarning.fulfilled, (state, action) => {
        state.warnings = state.warnings.filter((w) => w.id !== action.payload);
      })
      // Fetch All Justifications
      .addCase(fetchAllJustifications.fulfilled, (state, action) => {
        state.justifications = action.payload;
      })
      // Fetch Justifications by Warning ID
      .addCase(fetchJustificationsByWarningId.fulfilled, (state, action) => {
        state.warningJustifications = action.payload;
      })
      // Create Justification
      .addCase(createJustification.fulfilled, (state, action) => {
        state.justifications.push(action.payload);
        state.warningJustifications.push(action.payload);
      })
      // Update Justification Status
      .addCase(updateJustificationStatus.fulfilled, (state, action) => {
        const index = state.justifications.findIndex((j) => j.id === action.payload.id);
        if (index !== -1) {
          state.justifications[index] = action.payload;
        }
        const warningIndex = state.warningJustifications.findIndex((j) => j.id === action.payload.id);
        if (warningIndex !== -1) {
          state.warningJustifications[warningIndex] = action.payload;
        }
      })
      // Update Justification
      .addCase(updateJustification.fulfilled, (state, action) => {
        const index = state.justifications.findIndex((j) => j.id === action.payload.id);
        if (index !== -1) {
          state.justifications[index] = action.payload;
        }
        const warningIndex = state.warningJustifications.findIndex((j) => j.id === action.payload.id);
        if (warningIndex !== -1) {
          state.warningJustifications[warningIndex] = action.payload;
        }
      });
  },
});

export default warningSlice.reducer;